/**
 * Public error code the compose-message endpoint returns when DMS cannot load the source record.
 * Shared here so the browser can distinguish it from an AI provider failure.
 */
export const COMPOSE_MESSAGE_RECORD_CONTEXT_UNAVAILABLE_CODE = 'prompt-bridge-067';
